import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import { use100vh } from 'react-div-100vh';

// Components
import { Box, Flex, Text, Center } from '@wegroup/design-system';
import LoadingOverlay from '../../../common/src/components/LoadingOverlay';

// Redux
import { useLouiseDispatch } from '../../../sales-conversation/src/store/redux/store';
import { loadSelectionState } from '../../../sales-conversation/src/store/redux/slices/selectionSlice';
import DevToolsIntro from '../components/dev/DevToolsIntro';
import QuestionHopper from '../components/dev/Hopper/QuestionHopper';
import Progressor from '../components/dev/Progressor/Progressor';
import ErrorPage from '../../../common/src/components/ErrorPage';
import ScrollableContentContainer from '../../../sales-conversation/src/components/layout/ScrollableContentContainer';
import { useFlowsRouteParams } from '../hooks/useFlowsRouteParams';
import { useFlowsDispatch } from '../../../common/src/utils/globalVariables';
import { setIsSessionActive } from '../store/redux/slices/flowsMetaDataSlice';

const DevToolsView: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { sessionId } = useFlowsRouteParams();
  const { page } = useParams<{ page: string }>();

  const flowsDispatch = useFlowsDispatch();
  const appDispatch = useLouiseDispatch();

  const [isLoading, setIsLoading] = useState(false);

  const height = `${use100vh()}px`;

  useEffect(() => {
    initial();
  }, []);

  const initial = async () => {
    // Load the existing redux state if it is non existant
    if (sessionId) {
      await appDispatch(loadSelectionState(sessionId));
    }
    flowsDispatch(setIsSessionActive(false));
    setIsLoading(false);
  };

  if (isLoading)
    return (
      <Box position="relative">
        <LoadingOverlay />
      </Box>
    );

  if (!sessionId)
    return (
      <Center>
        <Text textStyle="h5Headline">
          You need to start a session before you can use devtools
        </Text>
      </Center>
    );

  return (
    <Flex height={height} width="100%" flexDir="column" background="#fdfcff">
      <ScrollableContentContainer>
        {{
          overview: <DevToolsIntro />,
          hopper: <QuestionHopper />,
          progressor: <Progressor />,
        }[page] || <ErrorPage />}
      </ScrollableContentContainer>
    </Flex>
  );
};

export default DevToolsView;
